import styled from "styled-components";

export const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatusContainer = styled.div`
  width: 360px;
  max-width: 90%;
  padding: 28px 32px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Message = styled.p`
  margin-bottom: 0.8rem;
  color: #1a2744;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`;
